import React, { useEffect, useRef, useState } from "react";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import DroppableCalendar from "./DroppableCalendar";
import CommonToolbar from "./CommonToolbar";
import RelativeScroll from "../GlobalComponents/RelativeScroll";
import { getAllSchedules } from "../../services/scheduleServices";


function ScheduleEdit({ usersRoleData }) {
  const [loading, setIsLoading] = useState(false);
  const [rolesData, setRolesData] = useState([]);
  const [allEvents, setAllEvents] = useState([]);
  const [eventsLeft, setEventsLeft] = useState([]);
  const [eventsRight, setEventsRight] = useState([]);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedLeftCalendarDate, setSelectedLeftCalenderDate] = useState(null);
  const [selectedRightCalendarDate, setSelectedRightCalenderDate] = useState(null);

  const containerRef = useRef();
  const scrollClassName = "rbc-time-content";

  useEffect(() => {
    setRolesData([...(usersRoleData || [])]);
  }, [usersRoleData]);

  useEffect(() => {
    const { startDate, endDate } = formatDates(currentDate);
    fetchScheduleData(startDate, endDate, "initial");
  }, []);

  useEffect(() => {
    const { startDate, endDate } = formatDates(currentDate);
    fetchScheduleData(startDate, endDate, "dateChange");
  }, [currentDate]);

  useEffect(() => {
    if (selectedLeftCalendarDate) {
      handleCalendarDateChange(selectedLeftCalendarDate, "Room 1");
    }
  }, [selectedLeftCalendarDate]);

  useEffect(() => {
    if (selectedRightCalendarDate) {
      handleCalendarDateChange(selectedRightCalendarDate, "Room 2");
    }
  }, [selectedRightCalendarDate]);

  const handleCalendarDateChange = (selectedDate, room) => {
      if (!selectedDate) return;
      const selected = new Date(selectedDate);
      const { startDate, endDate } = formatDates(selected);
      fetchScheduleData(startDate, endDate, room);
  };

  const moveEvent = (id, targetCalendar) => {
    const event =
      eventsLeft.find((e) => e.id === id) || eventsRight.find((e) => e.id === id)

    if (targetCalendar === "left-calendar") {
      setEventsRight((prev) => prev.filter((e) => e.id !== id))
      setEventsLeft((prev) => [...prev, event])
    } else if (targetCalendar === "right-calendar") {
      setEventsLeft((prev) => prev.filter((e) => e.id !== id))
      setEventsRight((prev) => [...prev, event])
    }
  }

  const fetchScheduleData = async (startDate, endDate, target) => {
    // console.log('called', startDate, endDate, target)
    try {
      setIsLoading(true);

      startDate = new Date(startDate);
      startDate.setDate(startDate.getDate() - 2)

      endDate = new Date(endDate);
      endDate.setDate(endDate.getDate() + 2)

      const { scheduleDetails = [] } = await getAllSchedules({ startDate, endDate });

      const events = scheduleDetails.map(each => {
        const start = new Date(each.start);
        const end = new Date(each.end);
        const patientName = [each.patientFirstName, each.patientLastName].filter(Boolean).join(" ");

        return {
          ...each,
          id: each._id,
          start,
          end,
          title: each.clinicName || each.title,
          label: each.clinicName || each.title,
          patientName,
        };
      });

      if (target === "Room 1") {
        setEventsLeft(events.filter(e => e.room === "Room 1"));
      } else if (target === "Room 2") {
        setEventsRight(events.filter(e => e.room === "Room 2"));
      } else {
        setAllEvents(events);
        setEventsLeft(events.filter(event => event.room === "Room 1"));
        setEventsRight(events.filter(event => event.room === "Room 2"));
      }
    } catch (error) {
      console.error("Error fetching schedules:", error);
    } finally {
      setIsLoading(false);
    }
  };

const formatDates = (date) => {
  const startDate = new Date(date);
  startDate.setUTCHours(0, 0, 0, 0);

  const endDate = new Date(date);
  endDate.setUTCHours(23, 59, 59, 999);

  return {
    startDate: startDate.toISOString(),
    endDate: endDate.toISOString(),
  };
};

  // console.log('eventsLeft', eventsLeft)

  return (
    <div className="edit-section-main-container">
      <RelativeScroll scrollClassName={scrollClassName} />
      <CommonToolbar
        currentDate={currentDate}
        setCurrentDate={setCurrentDate}
      />

      <div ref={containerRef} className="edit-section">
        <DndProvider backend={HTML5Backend}>
          <div className="room-container">
            <h3>Room 1</h3>
            <DroppableCalendar
              name="room1"
              usersRoleData={rolesData}
              events={eventsLeft}
              setEvents={setEventsLeft}
              droppableId="left-calendar"
              moveEvent={moveEvent}
              currentDate={currentDate}
              setCurrentDate={setCurrentDate}
              className={scrollClassName}
              setSelectedLeftCalenderDate={setSelectedLeftCalenderDate}
            />
          </div>

          <div className="room-container">
            <h3>Room 2</h3>
            <DroppableCalendar
              name="room2"
              usersRoleData={rolesData}
              events={eventsRight}
              setEvents={setEventsRight}
              droppableId="right-calendar"
              moveEvent={moveEvent}
              currentDate={currentDate}
              setCurrentDate={setCurrentDate}
              setSelectedRightCalenderDate={setSelectedRightCalenderDate}
            />
          </div>
        </DndProvider>
      </div>
    </div>
  );
}

export default ScheduleEdit;
